import { useEffect } from 'react';
import { emitDeleteObject } from '../../../socket';
import { isOffline } from '../../../utils/helper';

/** Delete removes the selected objects, unless a text is being edited. */
const useDeleteKey = (canvasRef, saveStateToUndoStack) => {
    useEffect(() => {
        const onKeyDown = (event) => {
            if (event.key !== 'Delete') return;
            const canvas = canvasRef.current;
            if (!canvas) return;
            const active = canvas.getActiveObject();
            if (active && active.type === 'i-text' && canvas.isEditing) return;
            canvas.getActiveObjects().forEach((object) => {
                canvas.remove(object);
                saveStateToUndoStack();
                !isOffline() && emitDeleteObject(object.id);
            });
            canvas.discardActiveObject().renderAll();
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [canvasRef, saveStateToUndoStack]);
};

export default useDeleteKey;
